export const CARD_TYPE_ID = '2002';
export const C2P_TYPE_ID = '2005';

export const GROUPED_CARD_TYPE = {
  CARD: 'CARD',
  CLICK_TO_PAY: 'CLICK_TO_PAY',
};
